export default {
  baseApiUrl: process.env.REACT_APP_API_BASE_URL,
  baseSocketUrl: process.env.REACT_APP_BASE_WS_URL ?? 'https://dev-api-meta-horse.bappartners.com/stomp',
  tokenMARE: process.env.REACT_APP_TOKEN_MARE ?? '0',
  tokenGate: process.env.REACT_APP_TOKEN_GATE ?? '0',
  tokenEMAS: process.env.REACT_APP_TOKEN_EMAS ?? '0',
  linkH2H: process.env.REACT_APP_LINK_H2H ?? 'https://dev.head-2-head.net/register',
  linkYoutube: process.env.REACT_APP_LINK_YOUTUBE,
  linkTwitch: process.env.REACT_APP_LINK_TWITCH,
  chainId: process.env.REACT_APP_CHAIN_ID,
  chainIdDirect: process.env.REACT_APP_CHAIN_ID_DIRECT,
  linkRpcUrls: process.env.REACT_APP_SPEC_TRE,
  nameChain: process.env.REACT_APP_CHAIN_NAME,
  nameCurrency: process.env.REACT_APP_CURRENCY_NAME,
  linkBlockExplorerUrls: process.env.REACT_APP_LINK_BLOCK_EXPLORERURLS ?? 'https://testnet.spectre-scan.io/',
  valueDecimals: process.env.REACT_APP_VALUE_DECIMALS ?? 18,
  linkAndroid:
    process.env.REACT_APP_LINK_ANDROID ??
    ' https://meta-horse-prd-general.oss-ap-northeast-1.aliyuncs.com/_apk-files/metahorse_android_1.0.2.60_betatest.apk',
  linkIOS: process.env.REACT_APP_LINK_IOS ?? 'https://testflight.apple.com/join/EFZgK0qz',
  horseNFT: process.env.REACT_APP_HORSE_NFT ?? '0',
  horseNFT_v2: process.env.REACT_APP_HORSE_NFT_V2 ?? '0',
  horseFarm: process.env.REACT_APP_HORSE_FARM ?? '0',
  horseFarm_v2: process.env.REACT_APP_HORSE_FARM_V2 ?? '0',
  transporter: process.env.REACT_APP_HORSE_TRANSPORTER ?? '0',
  linkAirdropH2H: process.env.REACT_APP_LINK_AIRDROP_H2H ?? 'https://airdrop.head-2-head.net/',
  specialHorseFarm: process.env.REACT_APP_SPECIAL_HORSE_FARM ?? '0x9882175164329CC92a5701D497A3b9930113A991',
  specialHorseFarm_V2: process.env.REACT_APP_SPECIAL_HORSE_FARM_V2 ?? '0x9882175164329CC92a5701D497A3b9930113A991',
  guildFarm: process.env.REACT_APP_GUILD_FARM ?? '',
  guildFarm_V2: process.env.REACT_APP_GUILD_FARM_V2 ?? '',
  shopAP: process.env.REACT_APP_SHOP_AP ?? '0x0f6Dc18b755815258Aea0560E217dFb52BA498A6',
  itemNFT: process.env.REACT_APP_ITEM_NFT ?? '0xfDc0014cd2AbaF646CA710A4003453F12B39374F',
  tokenLicence: process.env.REACT_APP_TOKEN_LICENSE ?? '0x0929744C16489Af6c093D5A2Dc2D1ae2cB261e6A',
  tokenMultiLicence: process.env.REACT_APP_TOKEN_MULTI_LICENSE ?? '0xe2d6aDc6410605710E76884786a7C702F9c3B429',
  guildVault: process.env.REACT_APP_GUILD_VAULT ?? '',
  ticketNft: process.env.REACT_APP_TICKET_NFT ?? '',
}
